import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { LanguageProvider } from '../contexts/LanguageContext';

export default function IslamicLayout() {
  const { pathname } = useLocation();
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  // Restore LTR when leaving the Islamic section
  useEffect(() => {
    return () => {
      document.documentElement.setAttribute('dir', 'ltr');
      document.documentElement.classList.remove('islamic-rtl');
    };
  }, []);

  // Close sidebar on route change (same as Main.js)
  useEffect(() => {
    document.body.classList.remove('sidebar-show');
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <LanguageProvider>
      <React.Fragment>
        <Sidebar />
        <Header onSkin={setSkin} />
        <div className="main main-app p-3 p-lg-4">
          <Outlet />
          <Footer />
        </div>
      </React.Fragment>
    </LanguageProvider>
  );
}
